import React, { useState, useRef, useMemo } from "react";
import SuccessScreen from "../screens/SuccessSreen";

const FormContext = React.createContext({});

const FormProvider = ({ children, ...props }) => {
  const [ticketId, setTicketId] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  let sigPad = useRef({})

  const value = useMemo(() => ({
    ticketId,
    showSuccess,
    setShowSuccess,
    setTicketId,
    sigPad,
    ...props,
  }), [ticketId, showSuccess, props]);

  return (
    <FormContext.Provider value={value}>
      {children}
      {ticketId && <SuccessScreen />}
    </FormContext.Provider>
  );
};

export const useFormContext = () => {
  const context = React.useContext(FormContext);
  if (!context) {
    throw new Error("use `useFormContext` inside `FormProvider` ");
  }
  return context;
};

export default FormProvider;
